import { defineMessages } from 'react-intl';

export const customerReviewCardMessages = defineMessages({
  author: {
    id: 'customerReviews.reviewCard.author',
    defaultMessage: 'von {authorNickName} | {created}',
  },
  tagProLabel: {
    id: 'customerReviews.reviewCard.tag.pro.label',
    defaultMessage: 'Vorteile:',
  },
  tagContraLabel: {
    id: 'customerReviews.reviewCard.tag.contra.label',
    defaultMessage: 'Nachteile:',
  },
  responseTitle: {
    id: 'customerReviews.reviewCard.response.title',
    defaultMessage: 'Antwort von BAUR',
  },
});
